import { css } from '@emotion/react'

export const cssHomeBannerImage = css`
  display: block;
  width: 100%;
  height: auto;
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
  }
`
